exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ddMmSpacer{font-size:1em;line-height:1em}.confirmDuration{margin-top:10px}.promoCode{width:auto}.promoCodeValue{font-weight:700;color:#abd561}.expCvcRow>*{display:inline-block;vertical-align:middle}.expCvcRow span{font-size:2em}.expCvcRow label,.expCvcRow span{padding-left:15px;padding-right:15px}.cc-input,.cvc-input,.exp-input{width:auto}.gooberLeaps{margin:0;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/dashboard/buyNowModal.scss
// module id = 1292
// module chunks = 2